import { z } from "zod/v4";
import { FRONTIERS_SCHEMA } from "./frontiers";

const FRONTIERS = z.array(
  z.object({
    counter: z.number(),
    peer: z.templateLiteral([z.number()]),
  }),
);

const VERSION = z.object({
  id: z.number(),
  frontiers: FRONTIERS,
  job_id: z.number(),
  job_status: z.string(),
  latest: z.boolean().nullish(),
  updatedAt: z.string(),
  last_change_at: z.string(),
  contributors: z.array(
    z.object({
      id: z.number(),
      full_name: z.string().nullish(),
    }),
  ),
  locked_by_user_id: z.number().nullish(),
  locked_by_user: z
    .object({
      id: z.number(),
      full_name: z.string().nullish(),
    })
    .nullish(),
  lock_mode: z.string().nullish(),
  quoted_by_user_id: z.number().nullish(),
  paid_by_user_id: z.number().nullish(),
  paid_by_is_essential: z.boolean().nullish(),
  paid_by_paid_at: z.string().nullish(),
  paid_by_user: z
    .object({
      id: z.number(),
      full_name: z.string().nullish(),
    })
    .nullish(),
});

const MAP2D = z.object({
  id: z.number(),
  history: z.array(VERSION),
});

const SYNC_PACKET = z.object({
  mainState: z.any(),
  tempState: z.any(),
  map2d: MAP2D,
});
type SyncPacket = z.infer<typeof SYNC_PACKET>;

const DUPLICATE_TO_DRAFT = z.object({
  versionId: z.number(),
  previousFrontiers: FRONTIERS.nullable(),
  blank: z.boolean().optional(),
});
type DuplicateToDraftPacket = z.infer<typeof DUPLICATE_TO_DRAFT>;

const UPDATE_HISTORY = z.object({
  history: z.array(VERSION),
});
type UpdateHistoryPacket = z.infer<typeof UPDATE_HISTORY>;

const REFRESH_PACKET = z.object({
  map2d: MAP2D,
});
type RefreshPacket = z.infer<typeof REFRESH_PACKET>;

const GET_FRONTIERS_PACKET = z.object({
  frontiers: FRONTIERS_SCHEMA,
});
type GetFrontiersPacket = z.infer<typeof GET_FRONTIERS_PACKET>;

export const sendPacket = <T>(schema: z.ZodSchema<T>, packet: T) => {
  return schema.parse(packet);
};

function parsePacketSafe<T>(
  schema: z.ZodSchema<T>,
  packet: unknown,
): z.ZodSafeParseResult<T> {
  return schema.safeParse(packet);
}

function parsePacket<T>(schema: z.ZodSchema<T>, packet: unknown): T {
  return schema.parse(packet);
}

export type {
  SyncPacket,
  DuplicateToDraftPacket,
  UpdateHistoryPacket,
  RefreshPacket,
  GetFrontiersPacket,
};
export {
  SYNC_PACKET,
  DUPLICATE_TO_DRAFT,
  UPDATE_HISTORY,
  REFRESH_PACKET,
  GET_FRONTIERS_PACKET,
  parsePacket,
  parsePacketSafe,
};
